<template>
  <b-container>
    <h1>IT Locked Orders</h1>

    <p v-for="lock in locks" :key="lock.num">
      <router-link :to="{ name: 'View Order', params: {id: lock.num} }">{{lock.num}}</router-link> - 
      <em>{{lock.locked_by}}</em>
    </p>
  </b-container>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      locks: {type: Object, default() { return []; }}
    }
  },
  methods: {
    fetchLocks() {
      axios.get(`${BASE_API}/locks/`).then(r => {
        this.locks = r.data
      });
    }
  },
  mounted() {
    this.fetchLocks();
  }
  
}
</script>


// WEBPACK FOOTER //
// src/components/sales-order/reports/LockedOrders.vue